import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import {
  driversHistoryAsync,
  selectDriversHistoryListStatus,
} from "../fleetSlice";
import { AdvancedAnalyticsVehicles } from "../fleetApi";
import { AdvancedAnalyticsVehicleSidePanel } from "./AdvancedAnalyticsVehiclesSidePanel";
import "../../../../i18n/i18n";
import { SharedInterfaceAnalyticsVehiclesTab } from "./sharedInterface";
import {
  getDepartmentsByCompanyAsync,
  selectGetDepartmentsByCompanyStatus,
} from "../../departments/departmentsSlice";
import {
  listAllVehiclesInDbAsync,
  selectListAllVehiclesInDbStatus,
} from "../../vehicles/vehiclesSlice";

export const AnalyticsVehiclesTab = () => {
  const params = useParams();
  const company = useAppSelector(selectCompany);
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1];
  const dispatch = useAppDispatch();
  const driversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );
  const listAllVehiclesInDbStatus = useAppSelector(
    selectListAllVehiclesInDbStatus,
  );
  const getDepartmentsByCompanyStatus = useAppSelector(
    selectGetDepartmentsByCompanyStatus,
  );
  useEffect(() => {
    if (company && driversHistoryListStatus === "idle") {
      void dispatch(driversHistoryAsync(company.uuid));
    }
  }, [dispatch, company, driversHistoryListStatus]);

  useEffect(() => {
    if (company && listAllVehiclesInDbStatus === "idle") {
      void dispatch(listAllVehiclesInDbAsync({ companyUuid: company.uuid }));
    }
  }, [dispatch, company, listAllVehiclesInDbStatus]);

  useEffect(() => {
    if (company && getDepartmentsByCompanyStatus === "idle") {
      void dispatch(getDepartmentsByCompanyAsync(company.uuid));
    }
  }, [dispatch, company, getDepartmentsByCompanyStatus]);

  useEffect(() => {
    if (
      params.tab === "advanced_analytics" &&
      company &&
      !company.hasAdvancedAnalytics
    ) {
      navigate(`/${firstPath}`);
    }
  }, [params.tab, company, navigate, firstPath]);

  const sidePanelAction = useCallback(
    (props: Partial<AdvancedAnalyticsVehicles>) => {
      navigate(`/home/fleet/advanced_analytics/${props.uuid}`);
    },
    [navigate],
  );

  if (params.tab !== "advanced_analytics") {
    return;
  }

  return (
    <SharedInterfaceAnalyticsVehiclesTab
      sidePanelAction={sidePanelAction}
      sidePanel={<AdvancedAnalyticsVehicleSidePanel />}
    />
  );
};
